import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InquiryService } from '../../../services/inquiry.service';
import { MaterialModule } from '../../../material.module';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { FileUtilsService } from '../../../services/file-utils.service';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractInquiryCreateComponent } from '../../abstract-inquiry-create.component';
import { ActivePoolTypes } from '../../../models/inquiry.model';

@Component({
  selector: 'app-transfer-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    MatRadioModule
  ],
  templateUrl: './transfer-create.component.html',
  styleUrls: ['./transfer-create.component.scss']
})
export class TransferCreateComponent extends AbstractInquiryCreateComponent {

  TransferPoolTypes = ActivePoolTypes;

  constructor(
    fb: FormBuilder,
    service: InquiryService,
    snackBar: ModalSnackbarService,
    fileUtils: FileUtilsService
  ) {
    super(fb, service, snackBar, fileUtils);

    this.form = this.fb.group({
      acc: ['', [Validators.required, Validators.maxLength(50)]],
      pool: ['', Validators.required],
      body: ['',Validators.maxLength(400)],
      files: [[], [this.fileUtils.fileSizeValidator(20 * 1024 * 1024), this.fileUtils.minFileCountValidator(2)]] // 20MB
    });
  }

  submit() {
    if (this.form.invalid) return;

    const formData = new FormData();

    const body = `振替元となる出資口座番号 : ${this.form.value.acc}
振替先のプラン名 : ${this.form.value.pool}
補足 : ${this.form.value.body}`;

    let title = this.form.value.acc + ' ⇒ ' + this.form.value.pool;

    formData.append('category', '振替依頼');
    formData.append('title', title);
    formData.append('child[body]', body);

    this.form.value.files.forEach((file: File, i: number) => {
      formData.append(`attachments[]`, file, file.name);
    });

    this.service.uploadWithFile(formData).subscribe({
      next: () => {
        this.snackBar.show('振替依頼を作成しました', '/transfer');
      },
      error: () => {
        this.snackBar.show('作成に失敗しました');
      }
    });
  }
}
